// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.94.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.94.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  align-items: flex-start;
  display: flex;
}

.summary {
  color: var(--gray-08);
  display: block;
  flex: 1;
  font-family: var(--heading-font-family);
  font-size: var(--heading-font-size);
  line-height: var(--heading-line-height);
}

.summary-aside {
  display: flex;
  gap: var(--space-1);
}

.content {
  display: block;
  margin-top: var(--space-3);
}
`, "",{"version":3,"sources":["webpack://./src/ui/section/section.module.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,OAAO;EACP,uCAAuC;EACvC,mCAAmC;EACnC,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B","sourcesContent":[".header {\n  align-items: flex-start;\n  display: flex;\n}\n\n.summary {\n  color: var(--gray-08);\n  display: block;\n  flex: 1;\n  font-family: var(--heading-font-family);\n  font-size: var(--heading-font-size);\n  line-height: var(--heading-line-height);\n}\n\n.summary-aside {\n  display: flex;\n  gap: var(--space-1);\n}\n\n.content {\n  display: block;\n  margin-top: var(--space-3);\n}\n"],"sourceRoot":""}]);
// Exports
var ___CSS_LOADER_STYLE_SHEET___ = new CSSStyleSheet();
___CSS_LOADER_STYLE_SHEET___.replaceSync(___CSS_LOADER_EXPORT___.toString());
export default ___CSS_LOADER_STYLE_SHEET___;
